import React from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'
import ExclamationMark from '../../Assets/Images/icons/exclamationMark'

const InfoCard = ({ title, classes }) => {
  return (
    <div className={classes.container}>
      <ExclamationMark />
      <div className={classes.title}>{title}</div>
    </div>
  )
}

export default injectStyles(styles)(InfoCard)
